var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeCategoryDialog,
            visible: _vm.categoryDialogVisible,
            title: "选择类目"
          },
          on: {
            "update:visible": function($event) {
              _vm.categoryDialogVisible = $event
            }
          }
        },
        [
          _c("Category", {
            ref: "Category",
            attrs: {
              "is-for-component": 1,
              "component-category-no": _vm.dialogData.formData.categoryNo,
              "component-parent-no": _vm.categoryParentNo
            }
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeCategoryDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterCategoryDialog }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.handelSPUDialogClose,
            visible: true,
            title: _vm.dialogData.type == "add" ? "新增商品" : "修改商品"
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.dialogData.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "选择类目", prop: "categoryNo" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请选择", disabled: true },
                            model: {
                              value: _vm.dialogData.formData.categoryName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogData.formData,
                                  "categoryName",
                                  $$v
                                )
                              },
                              expression: "dialogData.formData.categoryName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSelCategory }
                            },
                            [_vm._v("选择")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称:", prop: "goodsName" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.dialogData.formData.goodsName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogData.formData,
                                  "goodsName",
                                  $$v
                                )
                              },
                              expression: "dialogData.formData.goodsName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单位:", prop: "goodsUnit" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.dialogData.formData.goodsUnit,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogData.formData,
                                  "goodsUnit",
                                  $$v
                                )
                              },
                              expression: "dialogData.formData.goodsUnit"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "规格:", prop: "goodsSpecification" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.dialogData.formData.goodsSpecification,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogData.formData,
                                  "goodsSpecification",
                                  $$v
                                )
                              },
                              expression:
                                "dialogData.formData.goodsSpecification"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.hideItems.includes("goodsOfficialPrice")
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "销售指导价:",
                        prop: "goodsOfficialPrice"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c("el-input", {
                                attrs: { clearable: "", placeholder: "请输入" },
                                model: {
                                  value:
                                    _vm.dialogData.formData.goodsOfficialPrice,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dialogData.formData,
                                      "goodsOfficialPrice",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dialogData.formData.goodsOfficialPrice"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "备注:", prop: "goodsDesc" } },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 14 } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "", placeholder: "请输入" },
                            model: {
                              value: _vm.dialogData.formData.goodsDesc,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.dialogData.formData,
                                  "goodsDesc",
                                  $$v
                                )
                              },
                              expression: "dialogData.formData.goodsDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.hideItems.includes("goodsImg")
                ? _c(
                    "el-form-item",
                    { attrs: { label: "商品图标：", prop: "goodsImg" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 14 } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入链接地址" },
                                on: {
                                  blur: _vm.onAddImgUrl,
                                  input: function($event) {
                                    return _vm.inputChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.addImgUrl,
                                  callback: function($$v) {
                                    _vm.addImgUrl = $$v
                                  },
                                  expression: "addImgUrl"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("upload-image", {
                                staticStyle: { display: "inline-block" },
                                attrs: {
                                  "file-size": 80,
                                  "is-press": true,
                                  "max-w-h": 1080,
                                  multiple: true,
                                  "auto-upload": true,
                                  height: "150px",
                                  width: "150px",
                                  tips: "尺寸1:1，自动压缩，不超过200kb"
                                },
                                on: { onUploadSuccess: _vm.uploadSuccess }
                              }),
                              _vm.dialogData.formData.goodsImg
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "goods-img bairun-margin-l"
                                    },
                                    [
                                      _c("el-image", {
                                        attrs: {
                                          src: _vm.dialogData.formData.goodsImg,
                                          fit: "fit",
                                          "preview-src-list":
                                            _vm.dialogData.formData.goodsImg
                                        }
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-image-viewer__btn el-image-viewer__close",
                                          on: { click: _vm.onDeleteImg }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-close"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogData.configTicketAble.includes(
                _vm.dialogData.formData.categoryNo
              )
                ? _c(
                    "el-form-item",
                    { attrs: { label: "赠送优惠券：" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-add" },
                          on: {
                            click: function($event) {
                              return _vm.onAddTicket()
                            }
                          }
                        },
                        [_vm._v("添加优惠券")]
                      ),
                      _c("br"),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.dialogData.formData.goodsTicket,
                            border: "",
                            stripe: "",
                            "max-height": "280px",
                            "tooltip-effect": "dark"
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "券编号", prop: "ticketRuleNo" }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "券名称", prop: "ticketName" }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "数量", prop: "num" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-input-number", {
                                        staticClass:
                                          "bairun-input-fill bairun-required",
                                        staticStyle: { height: "47px" },
                                        attrs: {
                                          placeholder: "数量",
                                          "controls-position": "right",
                                          min: 0,
                                          max: 999999999999
                                        },
                                        model: {
                                          value: scope.row.num,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "num", $$v)
                                          },
                                          expression: "scope.row.num"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              311544179
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "120px" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { size: "mini" },
                                          on: {
                                            click: function($event) {
                                              return _vm.onDelTicket(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v(" 删除 ")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              587241214
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handelSPUDialogClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.couponFormData.dialogVisible
        ? _c("CouponSelect", {
            attrs: { "goods-component-form-data": _vm.couponFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }